import VISA_ICON from "../assets/png/visa.png";
import VERVE_ICON from "../assets/png/verve.png";
import MASTER_CARD_ICON from "../assets/png/mastercard.png";
import AFRIGO_ICON from "../assets/png/afrigo.png";

export const CARDNUMBERMASK = [/[0-9]/,/\d/,/\d/,/\d/," ",/\d/,/\d/,/\d/,/\d/," ",
    /\d/,/\d/,/\d/,/\d/," ",/\d/,/\d/,/\d/,/\d/];
export const VERVECARDNUMBERMASK = [/[0-9]/,/\d/,/\d/,/\d/," ",/\d/,/\d/,/\d/,/\d/," ",
    /\d/,/\d/,/\d/,/\d/," ",/\d/,/\d/,/\d/,/\d/," ",/\d/,/\d/,/\d/];
export const AFRIGOCARDNUMBERMASK = [/[0-9]/,/\d/,/\d/,/\d/," ",/\d/,/\d/,/\d/,/\d/," ",
    /\d/,/\d/,/\d/,/\d/," ",/\d/,/\d/,/\d/,/\d/," ",/\d/,/\d/];
export const EXPIRYDATEMASK = [/[0-9]/, /\d/, "/", /\d/, /\d/];
export const CVCMASK = [/[0-9]/, /\d/, /\d/];

export const CARDICON = {
    VISA: VISA_ICON,
    MASTERCARD: MASTER_CARD_ICON,
    VERVE: VERVE_ICON,
    AFRIGO: AFRIGO_ICON
};

export const CARDARR = [
    "VISA",
    "MASTERCARD",
    "VERVE",
    "AFRIGO"
];

const CARD_COMPLETE_LENGTHS = {
    VERVE: 19,
    AFRIGO: 18,
};

// All accepted lengths per card type (VERVE allows 16 or 19)
export const CARD_VALID_LENGTHS = {
    VERVE: [16, 19],
    AFRIGO: [18],
};

const CARD_NUMBER_MASKS = {
    VERVE: VERVECARDNUMBERMASK,
    AFRIGO: AFRIGOCARDNUMBERMASK,
};

// Unknown type defaults to widest mask/length (VERVE) since it could still be one being typed
export const getCardCompleteLength = (cardType) =>
    CARD_COMPLETE_LENGTHS[cardType] ?? (cardType === "" ? 19 : 16);

export const getCardValidLengths = (cardType) =>
    CARD_VALID_LENGTHS[cardType] ?? [16];

export const getCardNumberMask = (cardType) =>
    CARD_NUMBER_MASKS[cardType] ?? (cardType === "" ? VERVECARDNUMBERMASK : CARDNUMBERMASK);
